export enum StatusColor {
  Finished = '#85FF98',
  Progress = '#FFBF85',
  Send = '#8ED6FF',
  Hanging = '#BCBCBC',
  Error = '#A31A10',
}
